import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: {
          screen: {
            home: {
              title: 'Home',
              header: {
                title: 'Welcome to\nInnowise Mobile',
              },
              introducingCard: {
                appForStartups: {
                  title: 'App for Startups',
                  subtitle:
                    'We deliver high-quality end-to-end software development services',
                },
                enterpriseDevelopment: {
                  title: 'Enterprise Development',
                  subtitle:
                    'Enhance your in-house IT department with our experienced professionals',
                },
                servicesForPartners: {
                  title: 'Services for Partners',
                  subtitle:
                    'Consult with our IT experts on how to create robust IT solutions',
                },
              },
              activities: {
                title: 'What do we do\nas mobile development team?',
                description:
                  'From the first idea to the big launch, our web development consulting services have got you covered. We meticulously analyze your code, infrastructure, and user interactions to pinpoint any opportunities for optimization, security improvements and – most importantly – an exceptional user experience.',
                card: {
                  processAudit: {
                    title: 'Process audit',
                    subtitle:
                      'Through a thorough analysis of project workflows, methodologies, and documentation, we pinpoint the root causes of delays and budget overruns – providing practical advice to optimize web development and boost efficiency.',
                  },
                  codeAudit: {
                    title: 'Code audit',
                    subtitle:
                      'By digging deep into your codebase, our experts identify and rectify vulnerabilities, inefficiencies, and structural shortcomings – ensuring your web solution is built on a solid foundation.',
                  },
                  uiAudit: {
                    title: 'UI/UX audit',
                    subtitle:
                      'We pinpoint UI/UX bottlenecks and provide a detailed roadmap of actionable improvements – guaranteeing a straightforward and intuitive interface that increases user satisfaction and boosts conversion rates.',
                  },
                  architecture: {
                    title: 'Architecture consulting services',
                    subtitle:
                      'Our team of experts combs through your functional and non-functional requirements, designing a custom-made architectural blueprint that optimizes performance, scalability, and security.',
                  },
                  cloud: {
                    title: 'Cloud migration services',
                    subtitle:
                      'To seize the benefits of cloud migration, we craft a seamless transition strategy based on your software’s unique traits and readiness, selecting optimal cloud services and migration methods for your specific needs.',
                  },
                  compliance: {
                    title: 'Compliance management services',
                    subtitle:
                      'Staying compliant is crucial, and we’re here to make it easy. We’ll set up a solid compliance program just for you – complete with airtight processes, detailed documentation, and thorough employee training so you hit all security and privacy regulations from the outset.',
                  },
                },
              },
              industries: {
                title: 'Industries',
                card: {
                  healthcare: {
                    title: 'Healthcare:',
                    subtitle:
                      'High-precision and detailed 3D models of the human body, covering physiological systems, muscles, skeletal structures, and pathologies.',
                  },
                  finance: {
                    title: 'Finace & banking',
                    subtitle:
                      'High-precision and detailed 3D models of the human body, covering physiological systems, muscles, skeletal structures, and pathologies.',
                  },
                  eLearning: {
                    title: 'eLearning & Education',
                    subtitle:
                      'High-precision and detailed 3D models of the human body, covering physiological systems, muscles, skeletal structures, and pathologies.',
                  },
                },
                button: 'See all industries',
              },
              development: {
                title: 'Development Process',
                step: {
                  planning: {
                    title: 'Planning',
                    description:
                      'We offer a comprehensive redesign of your website, integrating modern design principles, improving UX/UI, and adding innovative features to elevate the overall user experience.',
                  },
                  meetings: {
                    title: 'Daily meetings',
                    description:
                      'Daily meetings help the team stay on top of tasks and ensure consistency.',
                  },
                  demo: {
                    title: 'Demo',
                    description:
                      'A demo allows you to demonstrate development progress and get feedback from stakeholders.',
                  },
                  review: {
                    title: 'Code review',
                    description:
                      'Code reviews ensure code quality and help maintain development standards.',
                  },
                  grooming: {
                    title: 'Grooming',
                    description:
                      'During the grading phase, the team refines tasks and prioritizes them for upcoming sprints.',
                  },
                  retrospective: {
                    title: 'Retrospective',
                    description:
                      'A retrospective allows the team to evaluate progress and identify areas for improvement.',
                  },
                },
              },
              faq: {
                title: 'FAQ',
                accordion: {
                  cloudTechnologies: {
                    question: 'What are cloud-based technologies?',
                    answer:
                      'Cloud computing technology gives users access to storage, files, software, and servers through their internet-connected devices: computers, smartphones, tablets, and wearables. Cloud computing providers store and process data in a location that’s separate from end users.',
                  },
                  difference: {
                    question:
                      'What is the difference between web and cloud applications?',
                    answer:
                      'Web applications run on specific web servers, while cloud applications operate on remote cloud servers, providing enhanced scalability, accessibility, and data security. The choice between the two depends on businesses and users specific needs and preferences in seeking efficient and reliable software solutions.',
                  },
                  cloudAppDevelopment: {
                    question: 'What is cloud application development?',
                    answer:
                      'Cloud application development is the process through which a Cloud-based app is built. It involves different stages of software development, each of which prepares your app to go live and hit the market. The best Cloud app development teams use SecOps, DevOps practices and tools like Kubernetes.',
                  },
                  cloudAppBenefits: {
                    question: 'What are the benefits of cloud applications?',
                    answer:
                      'You can spin up new instances or retire them in seconds, allowing developers to accelerate development with quick deployments. Cloud computing supports new innovations by making it easy to test new ideas and design new applications without hardware limitations or slow procurement processes.',
                  },
                  cloudComputingTypes: {
                    question: 'What are the types of cloud computing?',
                    answer:
                      'The main three types of cloud computing are public cloud, private cloud, and hybrid cloud. Within these deployment models, there are four main services: infrastructure as a service (IaaS), platform as a service (PaaS), software as a service (SaaS), and serverless computing.',
                  },
                  cloudServicesTypes: {
                    question: 'What are the types of cloud services?',
                    answer:
                      'The main three types of cloud computing are public cloud, private cloud, and hybrid cloud. Within these deployment models, there are four main services: infrastructure as a service (IaaS), platform as a service (PaaS), software as a service (SaaS), and serverless computing.',
                  },
                },
              },
              portfolio: {
                title: 'Explore our Portfolio',
                items: [
                  {
                    id: 'e-payment-ecosystem',
                    title: 'E-payment ecosystem with mobile platform',
                    category: ['Fintech & Banking', 'Web', 'Mobile'],
                    technologies: ['Spring Boot', 'Swift', 'Kotlin', 'Java'],
                  },
                  {
                    id: 'truck-fleet-management',
                    title: 'Truck fleet management system',
                    category: ['Healthcare', 'Education', 'AR', 'Mobile'],
                    technologies: ['Java', 'iOS'],
                  },
                  {
                    id: 'healthcare-monitoring',
                    title: 'Remote patient monitoring platform',
                    category: ['Healthcare', 'Education', 'AR', 'Mobile'],
                    technologies: ['Java', 'iOS'],
                  },
                  {
                    id: 'healthcare-monitoring',
                    title: 'Truck fleet management system',
                    category: ['Healthcare', 'Education', 'AR', 'Mobile'],
                    technologies: ['Java', 'iOS'],
                  },
                  {
                    id: 'healthcare-monitoring',
                    title: 'Truck fleet management system',
                    category: ['Healthcare', 'Education', 'AR', 'Mobile'],
                    technologies: ['Java', 'iOS'],
                  },
                ],
              },
            },
            product: {
              title: 'Portfolio',
            },
            contact: {
              title: 'Start Partnership with Us',
              text: 'Partner with us',
              form_title:
                "Fill out the form below and we'll get back to you once we've processed your request.",
              form_button: {
                loading: 'Loading...',
                send: 'Send',
              },
              form_close: 'Close',
              form_success: {
                title: 'Thank you!',
                second_line: 'Your message has been sent.',
                third_line:
                  "We'll process your request and contact you back as soon as possible.",
              },
              form_error: {
                title: 'Something went wrong.',
                second_line: "Your message hasn't been sent.",
                third_line: 'Please, try later.',
              },
              form_loading: {
                title: 'Your request is being processed.',
                second_line: 'Please wait a little bit',
              },
              card: {
                title: 'What happens next?',
                step_1:
                  'Having received and processed your request, we will reach you shortly to detail your project needs and sign an NDA to ensure the confidentiality of information.',
                step_2: `After examining requirements, our analysts and developers devise
                a project proposal with the scope of works, team size, time and
                cost estimates.`,
                step_3: `We arrange a meeting with you to discuss the offer and come to
                an agreement.`,
                step_4: `We sign a contract and start working on your project as quickly
                as possible.`,
              },
              formDisclaimer:
                'Please be informed that when you click the Send button Innowise will process your personal data in accordance with our <bold>Privacy Policy</bold> for the purpose of providing you with appropriate information.',
            },
            about: {
              title: 'About Us',
              teamAchievements: {
                title: 'About the mobile development team',
              },
              aboutSpecialists: {
                title: 'Out specialists',
              },
              listOfPlatforms: {
                title: 'Platforms',
                text: 'For all the projects you see here, permission for demonstration has been obtained from their customers.',
              },
              listOfDomains: {
                title: 'Domains',
              },
            },
            portfolio: {
              filters: {
                filter: 'Filter',
                sort: 'Sort',
                platform: 'Platform',
                region: "Client's Region",
                technology: 'Technology',
                domain: 'Industry',
                show: 'Show',
              },
              updates: {
                updates: 'Updates',
                newProjectAdded: '1 new project was added',
                viewCase: 'View case',
              },
              not_found: 'No projects found',
            },
            ourproducts: {
              title: 'Our-products',
              someContent: {
                title: 'Some content',
                text: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam non fermentum ante.
                 Ut ornare augue quis mi rhoncus efficitur. Suspendisse potenti. Sed eleifend nibh eget molestie ultricies. 
                 Quisque commodo massa quis sapien porttitor, vitae commodo est vulputate. Phasellus convallis leo tellus, 
                 quis sodales neque suscipit ut. Donec imperdiet luctus felis, eu tristique quam. Pellentesque in magna blandit, 
                 semper quam quis, suscipit libero.`,
              },
            },
            project: {
              related: 'Related Projects',
              expertises: 'Expertises',
              technologies: 'Technologies',
              achievements: 'Achievements',
              privateDistributionTitle: 'Private Distribution',
              privateDistributionText: 'Application is in the process of release',
            },
          },
          utils: {
            card: {
              allocation: {
                take_part: 'Took part in development',
                scratch: 'Implemented from scratch',
              },
            },
          },
          error: 'Error...',
          language: 'EN',
          button: {
            viewAll: 'View All',
          },
        },
      },
    },
  });

export default i18n;
